import { DeletedOption, Step } from '.';

export const ValueOrigin = {
  static: 'static',
  automation_variable: 'automation_variable',
} as const;

export type ValueOrigin = keyof typeof ValueOrigin;

export const DurationUnit = {
  hours: 'hours',
  minutes: 'minutes',
  days: 'days',
} as const;

export type DurationUnit = keyof typeof DurationUnit;

export type SkipNonWorkingDays = boolean | null;

export type DelayStep = Step & {
  type: 'delay';
  goalType: false;
  details: {
    minutes: number | null | undefined;
    hours: number | null | undefined;
    days: number | null | undefined;
    weeks: number | null | undefined;
    months: number | null | undefined;
    years: number | null | undefined;
    daysSpecificTime:
      | {
          days?: any;
          time?: any;
        }
      | null
      | undefined;
    skipNonWorkingDays: SkipNonWorkingDays;
    valueOrigin: ValueOrigin | null;
    durationUnit: DurationUnit | null;
    variable: DeletedOption;
  };
  description: string | null | undefined;
  userDescription: string | null | undefined;
};
export const WaitTime = {
  never: 'never',
  delay: 'delay',
  specific_datetime: 'specific_datetime',
};

export type WaitTime = keyof typeof WaitTime;
